"use client";

import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
} from "@/components/ui/sidebar";
import { m } from "@/paraglide/messages";
import { CollapsibleItem, type NavAreaItem } from "./NavItems";

export function NavUserArea({ items }: { items: NavAreaItem[] }) {
	return (
		<SidebarGroup>
			<SidebarGroupLabel>{m.jolly_left_wolf_trust()}</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => (
					<CollapsibleItem item={item} key={item.title} />
				))}
			</SidebarMenu>
		</SidebarGroup>
	);
}
